import {Modal} from 'antd';
import {
  deleteExternal,
  downloadMeetingSign,
  getDevice,
  getInviteFlag,
  getMeetingAgenda,
  getMeetingDevice,
  getMeetingInfo,
  getMeetingSvc,
  getMeetingUsers,
  getMeetingVideo,
  getNoticeConfig,
  getSignInfo,
  getSvc,
  reSign,
  saveAgenda,
  saveExternal,
  saveMeetingDevice,
  saveSvc,
  saveVideoApplyFuc,
  sendMsgToUser
} from '../services/meetingInfo';
import * as cmmaService from '../services/cmmaService';
import {PATHS, RES_STATUS} from '../utils/constants';
import {submitFace} from '../services/account';

export default {
  namespace: 'meetingInfo',
  state: {
    currentTab: 1,
    meeting: {},
    meetingAgenda: [],
    meetingSign: [],
    svcData: [], //会议服务数据
    meetingDevice: [],
    allDevice: [],
    allDeviceIncludeDel: [],
    meetingId: '',
    bookAble: true,
    meetingSvcData: {},
    meetingVideoData: {},
    mainTainList: [],
    showLiveOrVideoTab: false,
    noticeConfig: {},
    noticeKeys: [],
    onlyVideo: 0,
    inviteFlag: 1, //0:关，1:开
    signTime: 15, //默认时间
    fulInviteList: []
  },
  reducers: {
    set(state, { payload }) {
      return { ...state, ...payload };
    },
    setRoomInfo(state, { payload }) {
      return { ...state, meeting: { roomInfo: payload } };
    }
  },
  effects: {
    *getMeetingInfo({ payload, resolve, reject }, { call, put, select }) {
      const { meetingId = 0 } = payload;
      if (meetingId > 0) {
        const locale = yield select(state => state.i18n.locale);
        const { status, data, msg } = yield call(getMeetingInfo, {
          meetingId,
          locale
        });
        if (RES_STATUS.success === status) {
          const meetingData = data;
          //回显预约了访客的外部参会人的复选框
          if (meetingData.fuIds && meetingData.fuIds.length > 0) {
            const fuResult = yield call(
              cmmaService.getFuIdListByMeetingId,
              meetingId,
              locale
            );
            if (fuResult.status === 0) {
              meetingData.fulInviteList = fuResult.data.fuIdList;
            }
          }
          if (data.members || data.fuIds || data.holdId) {
            const res = yield call(getMeetingUsers, {
              members: data.members || '',
              fuIds: data.fuIds || '',
              holderId: data.holdId || '',
              locale
            });
            if (0 == res.status) {
              meetingData.allUserInfo = res.data;
            }
          }
          // 获取视频会议相关数据
          if (data.cmmaMeeting === 1) {
            const result = yield call(cmmaService.getCmmaInfo, meetingId);
            meetingData.meetingCtrl = result.data;
          }
          yield put({ type: 'set', payload: { meeting: meetingData } });
        }
        return {status, msg};
      }
    },
    *updateRoomInfo({ payload }, { put }) {
      yield put({ type: 'setRoomInfo', payload });
    },
    *sendMsgToUser({ payload }, { select, call }) {
      const locale = yield select(state => state.i18n.locale);
      const { status } = yield call(sendMsgToUser, { payload, locale });
      const { messages } = yield select(state => state.i18n);
      if (status === 0) {
        Modal.success({ content: messages['message_send_msg_success'], okText: messages['modal_manage_btn_ok'] });
      } else {
        Modal.error({ content: messages['message_send_msg_fail'] });
      }
    },
    *updateBookAble({ payload }, { put }) {
      yield put({ type: 'set', payload });
    },
    *changeUserFace(
      {
        payload: { userId, userType, path }
      },
      { call, put, select }
    ) {
      const { meetingId } = yield select(state => state.meetingInfo);
      const { locale } = yield select(state => state.i18n);
      const { msg, status } = yield call(submitFace, {
        userId,
        userType,
        imgPath: path,
        lang: locale
      });

      if (status !== 0) {
        Modal.error({ content: msg });
      }
      yield put({ type: 'getSignInfo', payload: { meetingId } });
    },
    *saveExternalUser({ payload, resolve, reject }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { status, data, msg } = yield call(saveExternal, {
        external: payload,
        locale
      });
      if (status === 0) {
        resolve && resolve(data);
      } else {
        reject && reject(msg);
      }
    },
    *deleteExternalUser({ payload, resolve, reject }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { status, data, msg } = yield call(deleteExternal, {
        external: payload,
        locale
      });
      if (status === 0) {
        resolve && resolve(data);
      } else {
        reject && reject(msg);
      }
    },
    *filterByReserveType({ payload }, { call, put, select }) {
      const { meetingList } = yield select(state => state);
      const { filter } = meetingList;
      let newReserveType = [];
      if (filter.reserveType.some(s => s === payload.reserveType)) {
        newReserveType = filter.reserveType.filter(
          s => s !== payload.reserveType
        );
      } else {
        newReserveType = filter.reserveType.concat([payload.reserveType]);
      }
      yield put({
        type: 'setFilter',
        payload: { reserveType: newReserveType }
      });
      yield put({
        type: 'allMeeting',
        payload: {
          currentPage: defaultPagination.currentPage,
          pageSize: defaultPagination.pageSize
        }
      });
    },
    *getSvcInfo({}, { call, put, select }) {
      const { status, data } = yield call(getSvc, {});
      if (status === 0) {
        yield put({ type: 'set', payload: { svcData: data } });
      } else {
        console.log('获取会议服务信息失败');
      }
    },
    *getMeetingSvc(
      {
        payload: { meetingId }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const {data, status} = yield call(getMeetingSvc, { meetingId, locale });
      if (status === 0) {
        yield put({
          type: 'set',
          payload: { meetingSvcData: data }
        });
      } else {
        console.log('获取当前会议服务信息失败');
      }
    },
    *getMeetingVideo(
      {
        payload: { meetingId }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const {data, status} = yield call(getMeetingVideo, { meetingId, locale });
      if (status === 0) {
        const {
          meetingVideo,
          mainTainList,
          showLiveOrVideoTab
        } = data;
        yield put({
          type: 'set',
          payload: {
            meetingVideoData: meetingVideo || {},
            mainTainList: mainTainList || [],
            showLiveOrVideoTab: showLiveOrVideoTab || false
          }
        });
      } else {
        console.log('获取当前会议直录播信息失败');
      }
    },
    *saveVideoApply({ meetingVideo }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { messages } = yield select(state => state.i18n);
      const data = yield call(saveVideoApplyFuc, { locale, meetingVideo });
      if (0 == data.status) {
        Modal.success({ content: messages['message_broadcast_value1'], okText: messages['modal_manage_btn_ok'] });
        yield put({
          type: 'getMeetingVideo',
          payload: { meetingId: meetingVideo.meetingId }
        });
      } else {
        Modal.error({ content: data.msg });
      }
    },
    *getMeetingAgenda(
      {
        payload: { meetingId }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(getMeetingAgenda, { meetingId, locale });
      if (result.status === 0) {
        yield put({ type: 'set', payload: { meetingAgenda: result.data } });
      } else {
        console.log('获取会议议程失败', result.msg);
      }
    },
    *downloadSingInfo({payload:{meetingId}},{call,put,select}){
      const locale = yield select(state => state.i18n.locale);
      const { token } = yield select(state => state.login);
      yield call(downloadMeetingSign,{locale,meetingId,token});
    },
    *getSignInfo(
      {
        payload: { meetingId }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(getSignInfo, { meetingId, locale });
      if (result.status === 0) {
        yield put({ type: 'set', payload: { meetingSign: result.data } });
      } else {
        console.log('获取会议签到信息失败', result.msg);
      }
    },
    *getMeetingDevice(
      {
        payload: { meetingId }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(getMeetingDevice, { meetingId, locale });
      if (result.status === 0) {
        yield put({ type: 'set', payload: { meetingDevice: result.data } });
      } else {
        console.log('获取当前会议移动设备信息失败', result.msg);
      }
    },
    *saveAgenda(
      {
        payload: { type }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const { messages } = yield select(state => state.i18n);
      const { meetingAgenda, meetingId } = yield select(
        state => state.meetingInfo
      );
      //校验数据
      let flg = meetingAgenda.some(ma => {
        return (!ma.title || ma.title.trim() == '') && (!ma.user || ma.user.trim() == '') && (!ma.time || ma.time.trim() == '');
      });
      if (flg) {
        Modal.warning({
          content: messages['message_agenda_value1'],
          okText: messages['modal_manage_btn_ok']
        });
        return;
      }

      let data = [];
      meetingAgenda.map(item => {
        data.push({
          id: 0,
          title: item.title,
          meetingId: meetingId,
          time: item.time,
          user: item.user
        });
      });

      const result = yield call(saveAgenda, {
        locale,
        data: JSON.stringify(data),
        meetingId,
        type
      });
      if (result.status === 0) {
        Modal.success({
          title: messages['index_save_success']
        });
        yield put({ type: 'getMeetingAgenda', payload: { meetingId } });
      } else {
        Modal.error({ content: result.msg });
      }
    },
    *reSign(
      {
        payload: { id }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const { meetingId } = yield select(state => state.meetingInfo);
      const { messages } = yield select(state => state.i18n);
      const result = yield call(reSign, { id, locale });
      if (result.status === 0) {
        // yield put({type:"set",payload:{meetingSign:result.data}});
        Modal.success({ content: messages['sign_success'], okText: messages['modal_manage_btn_ok'] });
        yield put({ type: 'getSignInfo', payload: { meetingId } });
      } else {
        Modal.warning({ content: result.msg });
        yield put({ type: 'getSignInfo', payload: { meetingId } });
      }
    },
    *getDevice({ resolve, reject }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      // type：0.会议室设备,1.固定设备，2.移动设备
      const result = yield call(getDevice, { type: 2, locale, includeDel: 0 });
      if (result.status === 0) {
        let allDevice = result.data.filter(item => item.status == 0);
        yield put({
          type: 'set',
          payload: { allDeviceIncludeDel: result.data, allDevice }
        });
        resolve && resolve();
      } else {
        yield put({
          type: 'set',
          payload: { allDeviceIncludeDel: [], allDevice: [] }
        });
        reject && reject(result.msg);
      }
    },
    *saveMeetingDevice(
      {
        payload: { meetingDevices, type }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const { messages } = yield select(state => state.i18n);
      const { meetingId } = yield select(state => state.meetingInfo);
      let data = [];
      meetingDevices.map(md => {
        data.push({
          deviceId: md.id,
          number: md.selNum
        });
      });
      if (data.length == 0) {
        Modal.error({ content: messages['meeting_services_info_value5'] });
        return;
      }
      const result = yield call(saveMeetingDevice, {
        locale,
        meetingId,
        data: encodeURIComponent(JSON.stringify(data)),
        type
      });
      if (result.status === 0) {
        Modal.success({ content: messages['index_save_success'], okText: messages['modal_manage_btn_ok'] });
        yield put({ type: 'getMeetingDevice', payload: { meetingId } });
      } else {
        Modal.error({ content: result.msg });
      }
    },
    *saveMeetingService(
      {
        payload: { svcs, levelId, type ,skipPrice = 0},resolve,reject
      },
      { call, put, select }
    ) {
      if (!!!levelId) {
        const { messages } = yield select(state => state.i18n);
        Modal.error({ content: messages['meeting_services_info_value1'] });
        return false;
      }
      const locale = yield select(state => state.i18n.locale);
      const { meetingId } = yield select(state => state.meetingInfo);
      const { messages } = yield select(state => state.i18n);
      let svcApply = [];
      let hasZero = false;
      let hasNoRemarkItem = false;
      let hasNoFileItem = false;
      svcs.map(s => {
        s.number = s.number || 0;
        if (s.isOpen) {
          if (s.countState == 0 && s.number == 0) {
            hasZero = true;
          }
          if (
            s.describeState == 0 &&
            (s.newDescribe == '' || s.newDescribe == null)
          ) {
            hasNoRemarkItem = true;
          }
          if (s.uploadState == 0 && (s.file == null || s.file == '')) {
            hasNoFileItem = true;
          }
          svcApply.push({
            meetingId,
            svcId: s.id,
            name: s.name,
            remark: s.newDescribe,
            price: s.price,
            num: s.number,
            type: s.type.name || '',
            file: s.file,
            fileName: s.fileName
          });
        }
      });
      if (svcApply.length == 0) {
        Modal.warn({ content: messages['meeting_services_info_value1'] });
        return;
      }
      if (hasZero) {
        Modal.warn({ content: messages['meeting_services_info_value2'] });
        return;
      }
      if (hasNoRemarkItem) {
        Modal.warn({ content: messages['meeting_services_info_value3'] });
        return;
      }
      if (hasNoFileItem) {
        Modal.warn({ content: messages['meeting_services_info_value4'] });
        return;
      }
      const {status, msg, data} = yield call(saveSvc, {
        locale,
        data: svcApply,
        levelId,
        meetingId,
        type,
        skipPrice
      });
      if (status === 0) {
        resolve && resolve();
      } else {
        reject && reject({status,msg,data});
      }
    },
    *getNoticeConfig(_, { call, put, select }) {
      const { locale: lang } = yield select(state => state.i18n);
      const result = yield call(getNoticeConfig, lang);
      if (result.status === 0 && result.data) {
        const { noticeConfigs = [], noticeKeys = [], signTime } = result.data;
        yield put({
          type: 'set',
          payload: {
            noticeConfig: noticeConfigs,
            noticeKeys: noticeKeys,
            signTime
          }
        });
      } else {
        Modal.error({ content: result.msg });
      }
    },
    *getInviteFlag(_, { call, put, select }) {
      const { locale: lang } = yield select(state => state.i18n);
      const { status, data, msg } = yield call(getInviteFlag, lang);
      if (status === 0) {
        yield put({
          type: 'set',
          payload: { inviteFlag: data.invitationServiceFlag }
        });
      } else {
        Modal.error({ content: msg });
      }
    }
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname, query }) => {
        if (pathname === PATHS.meetingInfo) {
          let meetingId = query.meetingId || 0;
          dispatch({
            type: 'set',
            payload: {
              meetingId,
              currentTab: 1,
              meetingVideoData: {},
              mainTainList: [],
              showLiveOrVideoTab: false
            }
          });
          dispatch({ type: 'getNoticeConfig' });
          dispatch({ type: 'getInviteFlag' });
          if (meetingId > 0) {
            dispatch({ type: 'set', payload: { bookAble: true } });
            dispatch({ type: 'getMeetingSvc', payload: { meetingId } });
            dispatch({ type: 'getMeetingAgenda', payload: { meetingId } });
            dispatch({ type: 'getSignInfo', payload: { meetingId } });
            dispatch({ type: 'getSvcInfo', payload: {} });
            dispatch({ type: 'getMeetingDevice', payload: { meetingId } });
            dispatch({ type: 'getMeetingVideo', payload: { meetingId } });
          } else {
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meetingInfo.js